(function () {
    'use strict';

    const SDK_HOST = 'https://plugins-media.makeupar.com/c39981/sdk.js';
    const API_KEY = 'VBiwl3ppNJaEDdUs3s8lEg';
    const SDK_URL = `${SDK_HOST}?apiKey=${encodeURIComponent(API_KEY)}`;

    let selectedVariantId = null;
    let domReady = false;
    let sdkReady = false;
    let ymkInitialized = false;
    let initRetryCount = 0;

    /* ---------------------------
       Helpers
    --------------------------- */

    function loadSdkOnce() {
        const alreadyLoaded = Array.from(document.scripts).some((script) => {
            const src = script.getAttribute('src') || '';
            return src.includes(SDK_HOST);
        });
        if (alreadyLoaded) return;

        const script = document.createElement('script');
        script.async = true;
        script.src = SDK_URL;

        const firstScript = document.getElementsByTagName('script')[0];
        firstScript.parentNode.insertBefore(script, firstScript);
    }

    function getSectionRoot(fromNode) {
        if (fromNode && typeof fromNode.closest === 'function') {
            const colorTypeButton = document.querySelector('.vto-color-type');
            if (colorTypeButton) return colorTypeButton.closest('section') || document;
        }

        const colorTypeSelect = document.getElementById('vtoColorTypeSelect');
        if (colorTypeSelect) return colorTypeSelect.closest('section') || document;

        const ymkMount = document.getElementById('YMK-module');
        if (ymkMount) return ymkMount.closest('section') || document;

        return document;
    }
    function hideAllProductColors() {
        const colorBlocks = document.querySelectorAll('.productColors');

        colorBlocks.forEach(function(block) {
            block.style.display = 'none';
            block.classList.remove('activeColorProduct');
        });
    }
    function hideAllShadeGrids(sectionRoot) {
        sectionRoot.querySelectorAll('.productColors').forEach((grid) => {
            grid.style.display = 'none';
            grid.classList.remove('activeColorProduct');
        });
    }

    function showShadeGrid(sectionRoot, collectionId) {
        hideAllShadeGrids(sectionRoot);
        if (!collectionId) return;

        const grid = sectionRoot.querySelector(`.product${collectionId}.productColors`);
        if (!grid) return;

        grid.style.display = 'flex';
        grid.classList.add('activeColorProduct');
    }

    function clearActiveShadeLabel(sectionRoot) {
        sectionRoot.querySelectorAll('.tryonColorName').forEach((label) => {
            label.classList.remove('activeColor');
        });
    }

    function hideAddToCart(sectionRoot) {
        const wrapper = sectionRoot.querySelector('#globalAddToCartBtn');
        if (wrapper) wrapper.style.display = 'none';
        selectedVariantId = null;
    }

    function applyColorTypeToTiles(sectionRoot, colorTypeValue) {
        if (!colorTypeValue) return;

        sectionRoot.querySelectorAll('.applyColorsBlock').forEach((tile) => {
            tile.setAttribute('data-cType', colorTypeValue);
            tile.classList.remove('makeDisabled');
        });

        // Reset on color type change
        clearActiveShadeLabel(sectionRoot);
        hideAddToCart(sectionRoot);
        hideAllShadeGrids(sectionRoot);



    }

    /* ---------------------------
       YMK init
    --------------------------- */

    function initYmkOnce() {
        if (ymkInitialized) return;
        if (!domReady || !sdkReady) return;

        const mount = document.getElementById('YMK-module');
        if (!mount || !window.YMK) return;

        try {

            const isMobile = window.innerWidth <= 749;

            let config = { autoOpen: true };

            if (isMobile) {
                const sidePadding = 30;
                const width = Math.min(window.innerWidth - sidePadding, 420);

                config = {
                    autoOpen: true,
                    width: Math.round(width* 1.11 ),
                    height: Math.round(width * 1.40)
                };
            }

            window.YMK.init(config);

            ymkInitialized = true;

        } catch (error) {

            initRetryCount += 1;

            if (initRetryCount < 30) {
                setTimeout(initYmkOnce, 120);
            }
        }

        window.YMK.addEventListener('engineClosed', function() {
            document.querySelectorAll('.vto-color.active').forEach(el => {
                el.classList.remove('active');
                window.dataLayer.push({
                    event: 'ymk_engine_closed'
                });
            });

            if (typeof hideAllProductColors === 'function') {
                hideAllProductColors();
            }
        });

        window.YMK.addEventListener('reset', function() {
            document.querySelectorAll('.vto-color.active').forEach(el => {
                el.classList.remove('active');

            });

            if (typeof hideAllProductColors === 'function') {
                hideAllProductColors();
            }
        });
    }
    window.ymkAsyncInit = function () {
        sdkReady = true;


        initYmkOnce();



    };

    function moveAddToCartForMobile() {
        const isMobile = window.innerWidth <= 749;
        const addToCartButton = document.getElementById('globalAddToCartBtn');
        const activeColorsBlock = document.querySelector('.productColors.activeColorProduct');

        if (!addToCartButton) return;

        if (isMobile && activeColorsBlock) {
            activeColorsBlock.insertAdjacentElement('afterend', addToCartButton);
        } else {
            const chooseColor = document.getElementById('ChooseColor');
            if (chooseColor && !chooseColor.contains(addToCartButton)) {
                chooseColor.appendChild(addToCartButton);
            }
        }
    }





    /* ---------------------------
       Public functions used by Liquid onclick
    --------------------------- */

    window.applyCollection = function (element, collectionId) {
        const sectionRoot = getSectionRoot(element);

        sectionRoot.querySelectorAll('.colorsSet').forEach((el) => el.classList.remove('activeColor'));
        if (element) element.classList.add('activeColor');

        showShadeGrid(sectionRoot, collectionId);
        clearActiveShadeLabel(sectionRoot);
        hideAddToCart(sectionRoot);
    };

    window.applyColors = function (tileElement, ymkMethodName, shadeId) {
        const sectionRoot = getSectionRoot(tileElement);

        const typeSuffix = tileElement.getAttribute('data-ctype') || '';
        const isOneShade = tileElement.getAttribute('data-oneShade');

        clearActiveShadeLabel(sectionRoot);
        const label = tileElement.querySelector('.tryonColorName');
        if (label) label.classList.add('activeColor');

        if (ymkMethodName === 'applyMakeupBySkuSet' || isOneShade) {
            window.YMK[ymkMethodName](shadeId);
        } else {
            window.YMK[ymkMethodName](shadeId + typeSuffix);
        }

        selectedVariantId = tileElement.getAttribute('data-variant-id') || null;
        const footer = sectionRoot.querySelector('#vtoProductFooter');

        if (footer) {
            const image = footer.querySelector('.vto-product-image');
            const title = footer.querySelector('.vto-product-title');
            const description = footer.querySelector('.vto-product-description');
            const findStoreLink = footer.querySelector('.vto-find-store-btn');

            if (image) {
                image.src = tileElement.dataset.productImage || '';
                image.alt = tileElement.dataset.productTitle || '';
            }

            if (title) {
                title.textContent = tileElement.dataset.productTitle || '';
            }

            if (description) {
                description.textContent = tileElement.dataset.productDescription || '';
            }

            if (findStoreLink && tileElement.dataset.findStoreUrl) {
                findStoreLink.href = tileElement.dataset.findStoreUrl;
            }

            footer.style.display = 'flex';
        }

        const addToCartWrapper = sectionRoot.querySelector('#globalAddToCartBtn');
        if (addToCartWrapper) addToCartWrapper.style.display = 'block';
        moveAddToCartForMobile();
    };

    window.addToCart = function (event) {
        event.stopPropagation();
        if (!selectedVariantId) return;

        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: selectedVariantId, quantity: 1 }),
        }).catch((error) => console.error(error));
    };

    /* ---------------------------
       DOM bindings
    --------------------------- */

    document.addEventListener('DOMContentLoaded', function () {
        domReady = true;

        const sectionRoot = getSectionRoot();

        const colorTypeButtons = sectionRoot.querySelectorAll('.vto-color-type');
        const applyColorButtons = sectionRoot.querySelectorAll('.vto-apply-color');


        hideAllShadeGrids(sectionRoot);
        hideAddToCart(sectionRoot);

        if (colorTypeButtons.length) {
            colorTypeButtons.forEach(function (button) {
                button.addEventListener('click', function () {
                    const colorType = this.dataset.colorType;

                    colorTypeButtons.forEach(function (item) {
                        item.classList.remove('is-active');
                    });

                    this.classList.add('is-active');

                    applyColorTypeToTiles(sectionRoot, colorType);

                    applyColorButtons.forEach(function (button) {
                        button.classList.remove('is-active');
                    });

                    hideAllShadeGrids(sectionRoot);
                    initYmkOnce();
                });
            });
        }

        if (applyColorButtons.length) {
            applyColorButtons.forEach(function (button) {
                button.addEventListener('click', function () {
                    const collectionId = this.dataset.collectionId;

                    applyColorButtons.forEach(function (item) {
                        item.classList.remove('is-active');
                    });

                    this.classList.add('is-active');

                    showShadeGrid(sectionRoot, collectionId);
                    clearActiveShadeLabel(sectionRoot);
                    hideAddToCart(sectionRoot);
                    const selectionImpact = sectionRoot.querySelector('#selectionImpact');
                    selectionImpact.classList.add('is-visible');
                });
            });
        }


        initYmkOnce();

    });

    loadSdkOnce();
})();
